<template>
  <div id="page-product-details">
    <section-risk-codes-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Edit Lloyds Risk Code"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.sections.riskCodes.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SectionRiskCodesForm from './SectionRiskCodesForm';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "SectionEdit",
  components: {
    SectionRiskCodesForm,
  },
  mixins: [NotificationMixin, ViewModelMixin, SaveModelMixin],
  data() {
    return {
      loading: false,
      references: ['LloydsRiskCode_FK'],
      model: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    },
  },
  methods: {
    async fetch(sectionId) {
      try {
        this.loading = true;

        const {data} = await this.$api.facilities.sections.getRiskCode(
            sectionId,
            this.$route.params.riskCodeId
        );

        this.model = data.data;

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      delete params.id;

      try {
        const {data} = await this.$api.facilities.sections.updateRiskCode(
            params,
            this.$route.params.sectionId,
            this.$route.params.riskCodeId
        );

        this.notifySuccess('Section Risk Code updated');
        await this.$router.push({ name: 'facilities.sections.riskCodes.list' })
      } catch (e) {
        this.notifyError('Section Risk Code failed to be update');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
